import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/navbar/Navbar";
import BentoGrid from "./components/bento/BentoGrid";
import Footer from "./components/footer/Footer";
import PrivacyPolicy from "./privacypolicy";
import "./i18n";

function App() {
  return (
    <Router>
      <div className="w-full h-auto bg-bodyColor text-lightText px-4">
        <Navbar />
        <div className="max-w-screen-xl mx-auto">
          <Routes>
            <Route path="/" element={<BentoGrid />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
          <Footer />
        </div>
      </div>
    </Router>
  );
}

export default App;
